import React from 'react';
// import withAuthorization from './Login/withAuthorization';
// import Topbar from './Navigation/Topbar/Topbar'
import Sidebar from './navigation/sidebar/MySidebar'
import Content from './content/content'
// import Dataloader from '../data/Dataloader'
import { Provider } from 'react-redux'
import store from '../redux/store'
import { Router, Route } from 'react-router-dom';
import { PrivateRoute } from 'auth/PrivateRoute';
import { appHistory } from './History';
import { AuthWrapper } from 'auth/AuthWrapper';
import { InitPage } from './content/init/InitPage';
import { rootPath } from './navigation/routes';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from 'AppInsights/AppInsights';
// import { rootPath } from './navigation/routes';
// import { NotFound404Page } from './content/404/NotFound404Page';


function App()
{
  return (
    <AuthWrapper>
      <Router history={appHistory}>
        <Provider store={store}>
          <div className="App">
            <Route path={rootPath} component={InitPage} />
            <PrivateRoute path={rootPath} component={AppContent} />
          </div>
        </Provider>
      </Router>
    </AuthWrapper>
  );
}


export function AppContent()
{

  return (
    <React.Fragment>
      <Sidebar />
      <Content />
    </React.Fragment>
  );
};



// export { App }

export default withAITracking(reactPlugin, App);
